import {
  GamoraConstructorType,
  GamoraFoundationNode,
  GamoraFoundationNodeArgs,
} from '@ver.id/libs.internal.gamora';
import {
  HoruzProtocolChulakTaskManagerNode,
  HoruzProtocolChulakTaskManagerNodeArgs,
} from './manager.js';
import { IHoruz } from '../../../horuz.js';

/**
 * Children map
 * @public
 */
export interface HoruzProtocolChulakTaskNodeChildrenMap<TRoot extends IHoruz> {
  manager: GamoraConstructorType<HoruzProtocolChulakTaskManagerNode<TRoot>>;
}

/**
 * Args
 * @public
 */
export interface HoruzProtocolChulakTaskNodeArgs<
  TRoot extends IHoruz,
> extends GamoraFoundationNodeArgs<
  HoruzProtocolChulakTaskNodeChildrenMap<TRoot>
> {
  manager?: HoruzProtocolChulakTaskManagerNodeArgs<TRoot>;
}

/**
 * HoruzProtocolChulakTaskNode
 * @public
 */
export class HoruzProtocolChulakTaskNode<
  TRoot extends IHoruz,
> extends GamoraFoundationNode<
  HoruzProtocolChulakTaskNodeChildrenMap<TRoot>,
  TRoot
> {
  constructor(args: HoruzProtocolChulakTaskNodeArgs<TRoot>) {
    super({
      ...args,
      childMap: {
        manager: [HoruzProtocolChulakTaskManagerNode, args.manager ?? {}],
      },
    });
  }
}
